import TemplateView from '../../../../TemplateView'
import {AccessRights} from "../../../../constants"
import {PERMISSION_ICON_CLASS} from "../../../../permissions/constants"
import messageResource from '../../../../messageResource'
import {getInstance as tooltip} from '../../../../SimpleSingletonTooltip'

class PermissionsCellContent extends TemplateView {
    constructor({
        generateMoneyReportsEnabled,
        generateMoneyReportsTooltip,
        isTTAEnabled = false,
    }) {
        super()

        this.params = {
            generateMoneyReportsEnabled,
            generateMoneyReportsTooltip,
            isTTAEnabled,
        }

        this.state = {
            canManageUsers: false,
            canModifyTime: false,
            canManageScope: false,
            canGenerateMoneyReports: false,
            generateMoneyReportsTooltip: this.params.generateMoneyReportsTooltip,
            generateMoneyReportsEnabled: this.params.generateMoneyReportsEnabled,
        }

        this.onStateChanged(() => {
            this._updateIcons()
        })

        this.onStatePropertyChanged('generateMoneyReportsEnabled', (enabled) => {
            this.costReports.toggle(enabled)
        })
    }

    templateHtml() {
        return '<div class="permissions">' +
               '  <div class="icons">' +
               '    <div class="icon <%=manageUsers%>"/>' +
               '    <div class="icon <%=modifyTT%>"/>' +
               '    <div class="icon <%=manageScope%>"/>' +
               '    <div class="icon <%=costReports%>"/>' +
               '  </div>' +
               '</div>'
    }

    templateModel() {
        return {
            manageUsers: PERMISSION_ICON_CLASS[AccessRights.MANAGE_USERS],
            modifyTT: PERMISSION_ICON_CLASS[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK],
            manageScope: PERMISSION_ICON_CLASS[AccessRights.EDIT_HIERARCHY],
            costReports: PERMISSION_ICON_CLASS[AccessRights.GENERATE_MONEY_REPORTS]
        }
    }

    afterRender() {
        this.manageUsers = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.MANAGE_USERS]}`)
        this.modifyTT = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]}`)
        this.manageScope = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.EDIT_HIERARCHY]}`)
        this.costReports = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.GENERATE_MONEY_REPORTS]}`)
        this.costReports.toggle(this.params.generateMoneyReportsEnabled)

        const extraClass = 'permissionsTooltip'
        tooltip().subscribeToMouseEvents(this.manageUsers, () => {
            tooltip().setState({
                text: messageResource.getMessage('access_rights.manage_users'),
                extraClass,
            })
        })
        tooltip().subscribeToMouseEvents(this.modifyTT, () => {
            const msgKey = this.params.isTTAEnabled ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track'
            tooltip().setState({
                text: messageResource.getMessage(msgKey),
                extraClass,
            })
        })
        tooltip().subscribeToMouseEvents(this.manageScope, () => {
            tooltip().setState({
                text: messageResource.getMessage('access_rights.edit_hierarchy'),
                extraClass,
            })
        })
        tooltip().subscribeToMouseEvents(this.costReports, () => {
            tooltip().setState({
                text: this.state.generateMoneyReportsTooltip,
                extraClass,
            })
        })
    }

    _updateIcons() {
        this.manageUsers.toggleClass('inactive', !this.state.canManageUsers)
        this.modifyTT.toggleClass('inactive', !this.state.canModifyTime)
        this.manageScope.toggleClass('inactive', !this.state.canManageScope)
        this.costReports.toggleClass('inactive', !this.state.canGenerateMoneyReports)
    }
}

export default PermissionsCellContent



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PermissionsCellContent.js